import React from 'react';
import { useTranslation } from 'react-i18next';

import { SwitchGroup } from '../switchGroup/SwitchGroup';
import { Radio } from '../radio/Radio';
import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  isTakeAway: boolean,
  handleChangeTakeAway: Function,
  className?: string,
  size?: string,
};

const _TakeAwaySwitcher = ({ className, isTakeAway, handleChangeTakeAway, size }: Props) => {
  const { t } = useTranslation('cart');
  return (
    <SwitchGroup className={className}>
      <Radio
        name="orderType"
        onChange={handleChangeTakeAway}
        checked={isTakeAway}
        value="takeAway"
        size={size}
        label={t('takeAway')}
      />
      <Radio name="orderType" size={size} onChange={handleChangeTakeAway} checked={!isTakeAway} value="eatIn" label={t('eatIn')} />
    </SwitchGroup>
  );
};

export const TakeAwaySwitcher = withSpacingStyles(_TakeAwaySwitcher);
